/**
 * Have I Been Pwned — Pwned Passwords con k-anonymity (Vault F3a).
 *
 * Se manda SOLO el prefijo de 5 caracteres del SHA-1 de la passphrase; la API
 * devuelve todos los sufijos con ese prefijo y la comparación se hace acá. La
 * passphrase nunca sale del navegador. Falla ABIERTO: si no hay red, la
 * passphrase no se rechaza (el chequeo es una ayuda, no un gate).
 */

const RANGE_URL = 'https://api.pwnedpasswords.com/range/';

async function sha1Hex(text: string): Promise<string> {
  const data = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-1', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
}

export type PwnedResult = { checked: true; count: number } | { checked: false };

export async function checkPwnedPassphrase(passphrase: string): Promise<PwnedResult> {
  try {
    const hash = await sha1Hex(passphrase);
    const prefix = hash.slice(0, 5);
    const suffix = hash.slice(5);
    const res = await fetch(`${RANGE_URL}${prefix}`, { headers: { 'Add-Padding': 'true' } });
    if (!res.ok) return { checked: false };
    const body = await res.text();
    for (const line of body.split('\n')) {
      const [candidate, count] = line.trim().split(':');
      if (candidate === suffix) return { checked: true, count: Number(count) || 0 };
    }
    return { checked: true, count: 0 };
  } catch {
    return { checked: false };
  }
}

/** Estimación simple de fuerza para la barra del wizard (no reemplaza a HIBP). */
export function passphraseStrength(p: string): { score: 0 | 1 | 2 | 3 | 4; label: 'muy_debil' | 'debil' | 'aceptable' | 'fuerte' | 'muy_fuerte' } {
  if (!p) return { score: 0, label: 'muy_debil' };
  const words = p.trim().split(/[\s\-_.]+/).filter(Boolean).length;
  const classes = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(p)).length;
  const unique = new Set(p).size;
  let score = 0;
  if (p.length >= 12) score++;
  if (p.length >= 16 || words >= 4) score++;
  if (classes >= 3 || words >= 4) score++;
  if (p.length >= 20 && unique >= 10) score++;
  const labels = ['muy_debil', 'debil', 'aceptable', 'fuerte', 'muy_fuerte'] as const;
  return { score: score as 0 | 1 | 2 | 3 | 4, label: labels[score] };
}
